import * as React from 'react';

export default function SignupByOtpTip(_: { onClick?: () => void }) {
  return <></>;
}
